import { ADDRESS_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/AddressStep/constants';
import { PREFERENCES_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/PreferencesStep/constants';
import { RETAIL_PIN_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/common/steps/PinStep/constants';
import { RETAIL_UPGRADE_LOGIN_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/retailUpgrade/steps/LoginStep/constants';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import { STEP_NAMES } from '@interlayer/js/app/store/reducers/Registration/constants';

import { TRetailUpgradeData, TRetailUpgradeSteps } from './types';

export const RETAIL_UPGRADE_DATA: TRetailUpgradeData = {
    [STEP_NAMES.LOGIN_RETAIL_UPGRADE_STEP]: RETAIL_UPGRADE_LOGIN_DATA,
    [STEP_NAMES.PIN_RETAIL_UPGRADE_STEP]: RETAIL_PIN_DATA,
    [STEP_NAMES.ADDRESS_RETAIL_UPGRADE_STEP]: {
        ...ADDRESS_DATA,
        [VALIDATION_FIELDS.phone]: ''
    },
    [STEP_NAMES.PREFERENCES_RETAIL_UPGRADE_STEP]: PREFERENCES_DATA
};

export const RETAIL_UPGRADE_ORDERED_STEPS = [
    [STEP_NAMES.LOGIN_RETAIL_UPGRADE_STEP],
    [STEP_NAMES.PIN_RETAIL_UPGRADE_STEP],
    STEP_NAMES.ADDRESS_RETAIL_UPGRADE_STEP,
    STEP_NAMES.PREFERENCES_RETAIL_UPGRADE_STEP
];

export const RETAIL_UPGRADE_ORDERED_OBJECT_STEPS: Record<TRetailUpgradeSteps, number> = {
    [STEP_NAMES.RESET_PASSWORD_RETAIL_UPGRADE_STEP]: 0,
    [STEP_NAMES.LOGIN_RETAIL_UPGRADE_STEP]: 0,
    [STEP_NAMES.PIN_RETAIL_UPGRADE_STEP]: 1,
    [STEP_NAMES.ADDRESS_RETAIL_UPGRADE_STEP]: 2,
    [STEP_NAMES.PREFERENCES_RETAIL_UPGRADE_STEP]: 3
};
